// 회사소개
export default {
  path: '/:locale([en]*)?/company/:child?',
  name: 'Company',
  component: () => import('@/views/company/Index'),
  meta: {
    scroll: true,
    sitemap: {
      loc: '/company'
    }
  },
}
